/**
 * @file: 键盘鼠标事件封装
 * @author: jun.li@dmall.com
 */

import UUID from './uuid';
import Utils from './util';

var specialKeys;
var _fn;
var CALLBACK_CACHE = {};
var TRIGGER_TYPE;

specialKeys = {
    27: 'esc', 9: 'tab', 32: 'space', 13: 'return', 8: 'backspace', 145: 'scroll',
    20: 'capslock', 144: 'numlock', 19: 'pause', 45: 'insert', 36: 'home', 46: 'del',
    67: 'c',
    48: '0',
    35: 'end', 33: 'pageup', 34: 'pagedown', 37: 'left', 38: 'up', 39: 'right', 40: 'down',
    109: '-', 16: 'shift', 17: 'ctrl', 18: 'alt',
    112: 'f1', 113: 'f2', 114: 'f3', 115: 'f4', 116: 'f5', 117: 'f6', 118: 'f7', 119: 'f8',
    120: 'f9', 121: 'f10', 122: 'f11', 123: 'f12', 191: '/', 0: 'mouseleft', 1: 'mousecenter', 2: 'mouseright', 3: 'mousecenter'
};


TRIGGER_TYPE = {
    'ordered': 1, // 有序
    'unOrdered': 2, // 无序
    'include': 3 // 任何情况下，含有即可
}


// 这里是否要考虑事件问题，进行快速fire事件
// 这里可能要整体给个代理区域
// TODO：整个input不要用hotkey去代理事件，走其他方式去代理
function Hotkeys(el) {
    var self = this;

    self.pressedKeys = [];
    self.jEl = $(el);
    _fn.init(self);
}

Hotkeys.prototype = {
    clearAll: function() {
        var self = this,
            key;

        for (key in CALLBACK_CACHE) {
            self.unbind(key);
        }
    },

    unbind: function(hotkeyId) {
        var jEl = this.jEl;

        if (!hotkeyId) {
            return;
        }
        hotkeyId = typeof hotkeyId === 'function'
            ? hotkeyId.hotkeyId
            : hotkeyId;
        var callbackObj = CALLBACK_CACHE[hotkeyId];

        if (!callbackObj) {
            return;
        }
        jEl.unbind(callbackObj.eventType, callbackObj.callback);
        delete CALLBACK_CACHE[hotkeyId];
    },

    on: function() { // 按顺序，按流程处理
        var self = this,
            jEl = self.jEl,
            eventType, hotkey, callback, i, callbackObj,
            triggerType;

        // 数组情况
        if (Object.prototype.toString.call(arguments[0]) === '[object Array]') {
            for (i = 0; callbackObj = arguments[0][i]; ++i) {
                hotkey = callbackObj.hotkey || '';
                hotkey = hotkey.replace(/ /g, '');
                _fn.bindHotkey(this, callbackObj.eventType, hotkey, callbackObj.callback);
            }
            return;
        }
        eventType = arguments[0];
        hotkey = arguments.length == 2 ? '' : arguments[1];
        callback = arguments.length == 2 ? arguments[1] : arguments[2];
        hotkey = hotkey.replace(/ /g, '');
        triggerType = arguments[arguments.length - 1];
        triggerType = typeof triggerType == 'string' && TRIGGER_TYPE[triggerType] > 0 ? TRIGGER_TYPE[triggerType] : TRIGGER_TYPE.ordered;
        _fn.bindHotkey(this, eventType, hotkey, callback, triggerType);
    }
}

_fn = {
    bindHotkey: function(caller, eventType, hotkey, callback, triggerType) {
        var self = caller,
            jEl = caller.jEl;

        // 避免回调被覆盖，每次绑定的回调都予以存储
        callback.hotkeyId = new UUID().id;
        CALLBACK_CACHE[callback.hotkeyId] = {
            eventType: eventType,
            hotkey: hotkey,
            callback: function(e) {
                if (_fn.isInput(e)) {
                    return;
                }

                var key = _fn.getKey(e);
                var pressedKeys = self.pressedKeys;
                var command = $.extend(true, [], pressedKeys);

                // 这里进行过滤判断然后判断是否执行
                // 如果性能不行，直接走key-v的列表处理
                if (['mousewheel', 'DOMMouseScroll'].indexOf(eventType) >= 0) {
                    // 首先纠正按键的问题
                    key = 'mousecenter';
                }

                if (command.indexOf(key) < 0 && eventType !== 'mousemove' && key !== '') {
                    command.push(key);
                }

                command = command.join('+');

                // 有序的情况
                if (TRIGGER_TYPE.ordered == triggerType && (command == hotkey || hotkey.trim() == '')) {
                    return callback(e, pressedKeys);
                    // 无序的情况
                } else if (TRIGGER_TYPE.unOrdered == triggerType) {
                    // 仅仅是包含的情况
                } else if (TRIGGER_TYPE.include == triggerType && (('+' + command + '+').indexOf('+' + hotkey.trim() + '+') >= 0 || hotkey.trim() == '')) {
                    return callback(e, pressedKeys);
                }
            }
        }

        // 节流处理, mousemove时调用太频繁, 保持fps在60即可
        // jEl.get(0).addEventListener(eventType, CALLBACK_CACHE[callback.hotkeyId].callback, { passive: false });
        jEl.on(eventType, CALLBACK_CACHE[callback.hotkeyId].callback);
    },

    // TODO：之后考虑把这些绑定移除了
    init: function(caller) {
        var jEl = caller.jEl;

        // TODO：这里要屏蔽input、textarea的情况

        // 监听每个按钮是否按住
        // 这里已经进行提前处理，所以按理，所有事件注册都在之后，还是比较好解决
        jEl.on('keydown', function(e) {
            // 当command键处于按下状态时，其他键的keyup失效
            if (caller.pressedKeys[0] === 'command') {
                caller.pressedKeys.length = 1;
            }
            if (_fn.isInput(e)) {
                return;
            };
            var key = _fn.getKey(e),
                pressedKeys = caller.pressedKeys;

            // 这里是去重，避免按住不放重复压栈，因为几乎不可能有两个相同key的快捷键
            if (pressedKeys.indexOf(key) >= 0 || key === '') {
                return;
            }
            _fn.pushKey(caller, key);

            let command: string = pressedKeys.join('+');

            // 不阻止系统的键
            if (!_fn.isSySKey(command)) {
                return false;
            }
        });

        // 当command键处于按下状态时，其他键的keyup失效
        jEl.on('keyup', function(e) {
            if (_fn.isInput(e)) {
                return;
            };
            var key = _fn.getKey(e);

            // mac command key 清空所有
            if (key == 'command') {
                caller.pressedKeys = [];
            } else {
                _fn.clearKey(caller, key);
            }
        });

        jEl.on('blur', function() {
            caller.pressedKeys = [];
        });

        jEl.on('mousedown', function(e) {
            if (caller.pressedKeys[0] === 'command') {
                caller.pressedKeys.length = 1;
            }
            if (_fn.isInput(e)) {
                return;
            };
            var key = _fn.getKey(e),
                pressedKeys = caller.pressedKeys;

            // 这里是去重，避免按住不放重复压栈，因为几乎不可能有两个相同key的快捷键
            if (pressedKeys.indexOf(key) >= 0 || key === '') {
                return;
            }

            _fn.pushKey(caller, key);
        });

        jEl.on('mouseup', function(e) {
            if (_fn.isInput(e)) {
                return;
            };
            var key = _fn.getKey(e);
            _fn.clearKey(caller, key);
        });
    },
    isSySKey: function (key: string): boolean {
        let keys: string[] = ['ctrl+c', 'command+c', 'ctrl+v', 'command+v'];

        return keys.includes(key);
    },
    isInput: function(e) {
        return ['input', 'textarea'].indexOf((e.target.nodeName + '').toLowerCase()) >= 0;
    },
    getKey: function(event) {
        var key = specialKeys[event.code || event.keyCode || event.button] || event.key ||((event.originalEvent&&event.originalEvent.code)?event.originalEvent.code.toLowerCase().replace('key',''):'')|| '';
        key = key.toLowerCase();

        if (key === 'meta') {
            key = 'command';
        }

        if (event.keyCode >= 48 && event.keyCode <= 57 || event.keyCode >= 97 && event.keyCode <= 105) {
            key = 'number';
        }

        return key;
    },

    pushKey: function(caller, key) {
        caller.pressedKeys.push(key);
    },
    clearKey: function(caller, key) {
        var index;

        index = caller.pressedKeys.indexOf(key);
        if (index >= 0) {
            caller.pressedKeys.splice(index, 1);
        }
    }
}

// 处理为个单例，保持页面级单例，后续可以处理其他事情
let HT;

function init(): void {
    if (!HT) {
        HT = new Hotkeys(window);
    }
}

export default {
    init,
    clear: () => {
        HT && HT.clearAll();
    },
    on: (...arg) => {
        HT.on(...arg);
    }
};
